import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Checkbox,
} from "@mui/material";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import bell from "../../assets/images/bell.png";
import FormikInput1 from "../../shared/material-ui-formik/FormikInput1";
import FormikSelect from "../../shared/material-ui-formik/FormikSelect";
import { toast } from "react-toastify";
import { fetchAvailableRoomsByCatAndRoom } from "../../apis/services/RoomApiService";
import { CheckInValidations } from "../../shared/validations/AdminValidator";
import { makeCheckIn } from "../../apis/services/BookingApiService";
import moment from "moment";
import Loader from "../../layout/Loader";
import { useTranslation } from "react-i18next";
import ReactToPrint from "react-to-print";
import PrintAgreement from "../Agreement/PrintAgreement";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import {
  createRecord,
  fetchList,
  getRecord,
  updateCardRecord,
} from "../../apis/services/CommonApiService";
import { useDispatch, useSelector } from "react-redux";
import { getLoadingFailed, getLoadingSuccess } from "../../Reducer/authSlice";
import ConfirmDialog from "../../shared/components/ConfirmDialog";
import { IOSSwitch } from "./ReservationView";
import { cryptoEncryptData } from "../../utils/helper";
import { fetchHotelDetail } from "../../apis/services/HotelApiService";
import { VerifyCard } from "../../apis/services/VerifyCard";

const ReservationCheckIn = (props) => {
  // const bookingInfo = props.editedData;
  const handleDialogClose1 = props.handleDialogClose;
  const refreshData = props.refreshCheckInOutListCall;
  let {
    suToken,
    suOn,
    handleSuOn,
    setOpenMakePaymentDialog,
    setShowPaymentMessage,
  } = props;
  // console.log("bookingInfo", props.editedData);
  const { t } = useTranslation();
  let componentRef = useRef();
  const dispatch = useDispatch();

  const [yearList, setYearList] = useState([]);
  const month = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const [splitBill, setSplitBill] = useState(false);

  useEffect(() => {
    let currentMonth = moment().format("YYYY");
    let yearArray = [];
    for (let i = 0; i < 100; i++) {
      yearArray.push((i + Number(currentMonth)).toString());
    }
    setYearList(yearArray);
  }, []);

  const [bookingInfo, setBookingInfo] = useState(props.editedData);
  const [hotelSetting, setHotelSetting] = useState({
    is_agreement_mandatory: 1,
    is_deposit_card_mandatory: 1,
    is_hotel_smart_lock_enabled: 0,
  });
  const [lockStatus, setLockStatus] = useState(null);
  const [lockErrorMsg, setLockErrorMsg] = useState("");

  const getLockStatus = async () => {
    const lockId = bookingInfo?.bookingItemsData?.[0]?.lockDetail?.lock_id;
    if (!lockId) {
      setLockStatus(2);
      setLockErrorMsg("");
      return;
    }

    const result = await fetchList(
      ApiEndPoints.GET_LOCK_STATUS_FROM_TTLOCK + `/${lockId}`,
    );
    if (result?.status === 200) {
      if (result.data.errcode) {
        toast.error(t(result.data.errmsg));
        setLockErrorMsg(result.data.errmsg);
        setLockStatus(2);
      } else {
        setLockErrorMsg("");
        setLockStatus(result.data.state ?? 2);
      }
    } else {
      setLockErrorMsg("");
      setLockStatus(2);
    }
  };
  const getHotelDetail = async (hotelId) => {
    const result = await fetchHotelDetail(hotelId);
    if (result?.status === 200) {
      setHotelSetting({
        is_agreement_mandatory: result?.data?.is_agreement_mandatory,
        is_deposit_card_mandatory: result?.data?.is_deposit_card_mandatory,
        is_hotel_smart_lock_enabled: result?.data?.is_hotel_smart_lock_enabled,
      });

      if (+result?.data?.is_hotel_smart_lock_enabled === 1) {
        getLockStatus();
      }
    }
  };

  // const [loading, setLoading] = React.useState(false);
  const loading = useSelector((state) => state.auth?.loading);
  const [card, setCard] = React.useState({
    id: 0,
    user_id: "",
    card_holder_name: "",
    card_number: "",
    yyy: "",
    mm: "",
    cvv: "",
  });

  const [cardDetail, setCardDetail] = React.useState([
    {
      id: 0,
      user_id: "",
      card_holder_name: "",
      card_number: "",
      expiry_date: "",
      cvv: "",
      card_type: "",
    },
  ]);

  const [depositCard, setDepositCard] = React.useState({
    id: 0,
    user_id: "",
    card_holder_name: "",
    card_number: "",
    yyy: "",
    mm: "",
    cvv: "",
    card_passed: false,
  });

  const [selectedDepoCard, setSelectedDepoCard] = useState(0);
  const [verifyToken, setVerifyToken] = useState("");
  // console.log(card, depositCard, 81);

  const handleDepositCardChange = (e) => {
    setVerifyToken("");
    setDepositCard({ ...depositCard, [e.target.name]: e.target.value });
  };

  const setDepositCradsDetails = (e, value) => {
    setSelectedDepoCard(e.target.value);
    setVerifyToken("");
    if (e.target.value === 0) {
      setDepositCard({
        id: 0,
        user_id: "",
        card_holder_name: "",
        card_number: "",
        yyy: "",
        mm: "",
        cvv: "",
        card_type: "",
        card_passed: false,
      });
    } else {
      const data = cardDetail.find((item) => item.id === e.target.value);
      if (data) {
        setDepositCard({
          id: Number.parseInt(data?.id),
          user_id: data?.user_id,
          card_holder_name: data?.card_holder_name,
          card_number: data?.card_number,
          yyy: data?.expiry_date.split("-")[0],
          mm: data?.expiry_date.split("-")[1],
          cvv: data?.cvv,
          card_type: data?.card_type,
          card_passed:
            +e.target.value ===
            bookingInfo?.bookingDetails?.advance_deposit_credit_card_id,
        });
        setVerifyToken(data?.token);
      } else {
        setSelectedDepoCard(0);
        setDepositCard({
          id: 0,
          user_id: "",
          card_holder_name: "",
          card_number: "",
          yyy: "",
          mm: "",
          cvv: "",
          card_type: "",
          card_passed: false,
        });
      }
    }
  };

  const handleChangePrimaryCard = async () => {
    const bodyFormData = {
      booking_id: bookingInfo?.id,
      card_id: card?.id,
    };

    // console.log(bookingInfo?.bookingPaymentDetails?.booking_id, bodyFormData, 150)
    dispatch(getLoadingSuccess());
    const result = await updateCardRecord(
      bodyFormData,
      ApiEndPoints.CHANGE_PRIMARY_CARD,
    );
    if (result.status === 200) {
      toast.success(t("Primary Card Updated Successfully"));
      await fetchList(ApiEndPoints.GET_BOOKING_DETAILS + `/${bookingInfo?.id}`)
        .then((result) => {
          setBookingInfo(result?.data);
          dispatch(getLoadingFailed());
        })
        .catch((err) => dispatch(getLoadingFailed()));
    } else {
      dispatch(getLoadingFailed());
    }
  };

  const handleChangeDepositCard = async () => {
    const bodyFormData = {
      booking_id: bookingInfo?.id,
      credit_card_id: depositCard?.id,
    };
    dispatch(getLoadingSuccess());
    const result = await createRecord(
      bodyFormData,
      ApiEndPoints.SAVE_DEPOSIT_CARD,
    );
    if (result.status === 200) {
      toast.success(t("Deposit Card Updated Successfully"));
      await fetchList(ApiEndPoints.GET_BOOKING_DETAILS + `/${bookingInfo?.id}`)
        .then((result) => {
          setBookingInfo(result?.data);
          dispatch(getLoadingFailed());

          // dispatch(getLoadingFailed());
        })
        .catch((err) => dispatch(getLoadingFailed()));
    } else {
      dispatch(getLoadingFailed());
    }
  };

  const addCardDetail = async () => {
    if (
      card?.card_holder_name === "" ||
      card?.yyy === "" ||
      card?.card_number === "" ||
      card?.mm === ""
      // ||
      // card?.cvv === ""
    ) {
      toast.error(t("You Must Add Card Detail"));
      return;
    }

    if (card?.card_number?.length < 8) {
      toast.error("Please, enter valid card number");
      return;
    }

    if (documentDetail?.user_id === "") {
      if (documentDetail?.name === "") {
        toast.error(
          t("To confirm the Add Card, you must Add User in the Second step"),
        );
        return;
      }

      let userData = new FormData();
      userData.append("name", documentDetail?.name);
      userData.append("phone", documentDetail?.phone);
      userData.append("email", documentDetail?.email);
      userData.append("id_number", documentDetail?.id_number);
      userData.append("id_proof_type", documentDetail?.id_proof_type);
      userData.append("id_proof", documentDetail?.id_proof);
      userData.append("phone_code", documentDetail?.phone_code);
      userData.append("country", documentDetail?.country_id);
      userData.append("state", documentDetail?.state_id);
      userData.append("city", documentDetail?.city_id);
      // console.log(card,userData, 2092)
      dispatch(getLoadingSuccess());

      const UserResult = await createRecord(userData, ApiEndPoints.ADD_USER);
      // console.log(card,userData,UserResult, 2092)
      if (UserResult?.status === 200) {
        const name = card?.card_holder_name.trim().split(/\s+/);
        const expiry_date_yyy = card?.yyy.split("");

        const bodyFormData = {
          user_id: Number.parseInt(UserResult?.data?.id),
          card_number: cryptoEncryptData(
            Number.parseInt(card?.card_number)?.toString(),
          ),
          expiry_date: cryptoEncryptData(
            `${card?.mm}${expiry_date_yyy.at(-2)}${expiry_date_yyy.at(
              -1,
            )}`?.toString(),
          ),
          first_name: name[0],
          last_name: name[1] ? name[1] : "",
          security_code: cryptoEncryptData(card?.cvv?.toString()),
          address: documentDetail.address,
          postel_code: documentDetail.postel_code,
        };
        const result = await VerifyCard(bodyFormData, card);

        if (result?.status === 200) {
          const bodyFormData = result?.bodyFormData;

          // console.log("addCardDetail", bodyFormData);
          const results = await createRecord(
            bodyFormData,
            ApiEndPoints.ADD_USER_CARD_DETAIL,
          );
          if (results?.status === 200) {
            // console.log(results?.data, 2137, "if");
            getCradsDetail(UserResult?.data?.id);
            // setCradsDetail({target: results?.data?.id})
            setCard({
              id: Number.parseInt(results?.data?.id),
              user_id: results?.data?.user_id,
              card_holder_name: results?.data?.card_holder_name,
              card_number: results?.data?.card_number,
              yyy: results?.data?.expiry_date.split("-")[0],
              mm: results?.data?.expiry_date.split("-")[1],
              cvv: results?.data?.cvv,
              card_type: results?.data?.card_type,
            });
            setVerifyToken(results?.data?.token);
            toast.success(t(results.message));
            dispatch(getLoadingFailed());
          } else {
            dispatch(getLoadingFailed());
            toast.error(t(results.message));
          }
        } else {
          setVerifyToken("");
          dispatch(getLoadingFailed());
          // toast.error(t(result.message));
        }
      } else {
        dispatch(getLoadingFailed());
        toast.error(t(UserResult?.message));
      }
    } else {
      if (documentDetail?.user_id === "") {
        toast.error(
          t("To confirm the Add Card, you must Select User in the Second step"),
        );
        dispatch(getLoadingFailed());
        return;
      }

      const name = card?.card_holder_name.trim().split(/\s+/);
      const expiry_date_yyy = card?.yyy.split("");

      const bodyFormData = {
        user_id: Number.parseInt(documentDetail?.user_id),
        card_number: cryptoEncryptData(
          Number.parseInt(card?.card_number)?.toString(),
        ),
        expiry_date: cryptoEncryptData(
          `${card?.mm}${expiry_date_yyy.at(-2)}${expiry_date_yyy.at(-1)}`?.toString(),
        ),
        first_name: name[0],
        last_name: name[1] ? name[1] : "",
        security_code: cryptoEncryptData(card?.cvv?.toString()),
        address: documentDetail.address,
        postel_code: documentDetail.postel_code,
      };
      dispatch(getLoadingSuccess());

      // const result = await createRecord(
      //   bodyFormData,
      //   ApiEndPoints.VERIFY_USER_CARD_DETAIL +
      //     `?hotel_id=${documentDetail?.hotel_id}`
      // );
      const result = await VerifyCard(bodyFormData, card);

      if (result?.status === 200) {
        // toast.success(t("Card Verify Success"));
        const bodyFormData = result?.bodyFormData;
        // console.log("addCardDetail", bodyFormData);
        const results = await createRecord(
          bodyFormData,
          ApiEndPoints.ADD_USER_CARD_DETAIL,
        );
        if (results?.status === 200) {
          // console.log(results?.data, 2137);
          getCradsDetail(documentDetail?.user_id);

          setCard({
            id: Number.parseInt(results?.data?.id),
            user_id: results?.data?.user_id,
            card_holder_name: results?.data?.card_holder_name,
            card_number: results?.data?.card_number,
            yyy: results?.data?.expiry_date.split("-")[0],
            mm: results?.data?.expiry_date.split("-")[1],
            cvv: results?.data?.cvv,
            card_type: results?.data?.card_type,
          });
          setVerifyToken(results?.data?.token);
          toast.success(t(results.message));
          dispatch(getLoadingFailed());
        } else {
          dispatch(getLoadingFailed());
          toast.error(t(results.message));
        }
      } else {
        setVerifyToken("");
        dispatch(getLoadingFailed());
      }
    }
  };

  const addDepoCardDetail = async () => {
    if (
      depositCard?.card_holder_name === "" ||
      depositCard?.yyy === "" ||
      depositCard?.card_number === "" ||
      depositCard?.mm === ""
      // ||
      // depositCard?.cvv === ""
    ) {
      toast.error(t("You Must Add Card Detail"));
      return;
    }

    if (depositCard?.card_number?.length < 8) {
      toast.error("Please, enter valid card number");
      return;
    }

    if (documentDetail?.user_id === "") {
      if (documentDetail?.name === "") {
        toast.error(
          t("To confirm the Add Card, you must Add User in the Second step"),
        );
        return;
      }

      let userData = new FormData();
      userData.append("name", documentDetail?.name);
      userData.append("phone", documentDetail?.phone);
      userData.append("email", documentDetail?.email);
      userData.append("id_number", documentDetail?.id_number);
      userData.append("id_proof_type", documentDetail?.id_proof_type);
      userData.append("id_proof", documentDetail?.id_proof);
      userData.append("phone_code", documentDetail?.phone_code);
      userData.append("country", documentDetail?.country_id);
      userData.append("state", documentDetail?.state_id);
      userData.append("city", documentDetail?.city_id);
      // console.log(card,userData, 2092)
      dispatch(getLoadingSuccess());
      const UserResult = await createRecord(userData, ApiEndPoints.ADD_USER);
      // console.log(card,userData,UserResult, 2092)
      if (UserResult?.status === 200) {
        const name = depositCard?.card_holder_name.trim().split(/\s+/);
        const expiry_date_yyy = depositCard?.yyy.split("");

        const bodyFormData = {
          user_id: Number.parseInt(documentDetail?.user_id),
          card_number: cryptoEncryptData(
            Number.parseInt(depositCard?.card_number)?.toString(),
          ),
          expiry_date: cryptoEncryptData(
            `${depositCard?.mm}${expiry_date_yyy.at(
              -2,
            )}${expiry_date_yyy.at(-1)}`?.toString(),
          ),
          first_name: name[0],
          last_name: name[1] ? name[1] : "",
          security_code: cryptoEncryptData(depositCard?.cvv?.toString()),
          address: documentDetail.address,
          // postel_code: documentDetail.postel_code,
        };
        // const result = await createRecord(
        //   bodyFormData,
        //   ApiEndPoints.VERIFY_USER_CARD_DETAIL +
        //     `?hotel_id=${documentDetail?.hotel_id}`
        // );
        const result = await VerifyCard(bodyFormData, depositCard);

        if (result?.status === 200) {
          const bodyFormData = result?.bodyFormData;
          // console.log("addCardDetail", bodyFormData);
          const results = await createRecord(
            bodyFormData,
            ApiEndPoints.ADD_USER_CARD_DETAIL,
          );
          if (results?.status === 200) {
            // console.log(results?.data, 2137, "if");
            getCradsDetail(UserResult?.data?.id);
            // setCradsDetail({target: results?.data?.id})
            setCard({
              id: Number.parseInt(results?.data?.id),
              user_id: results?.data?.user_id,
              card_holder_name: results?.data?.card_holder_name,
              card_number: results?.data?.card_number,
              yyy: results?.data?.expiry_date.split("-")[0],
              mm: results?.data?.expiry_date.split("-")[1],
              cvv: results?.data?.cvv,
              card_type: results?.data?.card_type,
            });
            setVerifyToken(results?.data?.token);
            toast.success(t(results.message));
            dispatch(getLoadingFailed());
          } else {
            dispatch(getLoadingFailed());
            toast.error(t(results.message));
          }
        } else {
          setVerifyToken("");
          dispatch(getLoadingFailed());
        }
      } else {
        dispatch(getLoadingFailed());
        toast.error(t(UserResult?.message));
      }
    } else {
      if (documentDetail?.user_id === "") {
        toast.error(
          t("To confirm the Add Card, you must Select User in the Second step"),
        );
        return;
      }
      dispatch(getLoadingSuccess());

      const name = depositCard?.card_holder_name.trim().split(/\s+/);
      const expiry_date_yyy = depositCard?.yyy.split("");

      const bodyFormData = {
        user_id: Number.parseInt(documentDetail?.user_id),
        card_number: cryptoEncryptData(
          Number.parseInt(depositCard?.card_number)?.toString(),
        ),
        expiry_date: cryptoEncryptData(
          `${depositCard?.mm}${expiry_date_yyy.at(-2)}${expiry_date_yyy.at(-1)}`?.toString(),
        ),
        first_name: name[0],
        last_name: name[1] ? name[1] : "",
        security_code: cryptoEncryptData(depositCard?.cvv?.toString()),
        address: documentDetail.address,
        postel_code: documentDetail.postel_code,
      };
      // setLoading(true);
      const result = await VerifyCard(bodyFormData, depositCard);

      if (result?.status === 200) {
        const bodyFormData = result?.bodyFormData;

        // console.log("addCardDetail", bodyFormData);
        const results = await createRecord(
          bodyFormData,
          ApiEndPoints.ADD_USER_CARD_DETAIL,
        );
        if (results?.status === 200) {
          // console.log(results?.data, 2137);
          // setLoading(false);

          getCradsDetail(documentDetail?.user_id);
          setVerifyToken(results?.data?.token);
          toast.success(t(results.message));
          dispatch(getLoadingFailed());
        } else {
          // setLoading(false);
          dispatch(getLoadingFailed());
          toast.error(t(results.message));
        }
      } else {
        setVerifyToken("");
        dispatch(getLoadingFailed());
      }
    }
  };

  const [selectedCard, setSelectedCard] = useState(0);
  const setCradsDetail = (e) => {
    setSelectedCard(e.target.value);
    setVerifyToken("");
    if (e.target.value === 0) {
      setCard({
        id: 0,
        user_id: "",
        card_holder_name: "",
        card_number: "",
        yyy: "",
        mm: "",
        cvv: "",
        card_type: "",
      });
    } else {
      const data = cardDetail.find((item) => item.id === e.target.value);
      if (data) {
        setCard({
          id: Number.parseInt(data?.id),
          user_id: data?.user_id,
          card_holder_name: data?.card_holder_name,
          card_number: data?.card_number,
          yyy: data?.expiry_date.split("-")[0],
          mm: data?.expiry_date.split("-")[1],
          cvv: data?.cvv,
          card_type: data?.card_type,
        });
        setVerifyToken(data?.token);
      } else {
        setSelectedCard(0);
        setCard({
          id: 0,
          user_id: "",
          card_holder_name: "",
          card_number: "",
          yyy: "",
          mm: "",
          cvv: "",
          card_type: "",
        });
      }
    }
  };

  const handeleCardChange = (e) => {
    if (verifyToken) {
      setVerifyToken("");
    }
    setCard({ ...card, [e.target.name]: e.target.value });
  };

  const getCradsDetail = async (Id) => {
    // const user_ids = user_id;
    const result = await getRecord(Id, ApiEndPoints.GET_USER_CARD_DETAIL);
    const cardLists = [];
    if (result?.status === 200) {
      for (let j in result.data) {
        cardLists.push({
          id: result.data[j].id,
          user_id: result.data[j].user_id,
          card_holder_name: result.data[j].card_holder_name,
          card_number: result.data[j].card_number,
          expiry_date: result.data[j].expiry_date,
          cvv: result.data[j].cvv,
          card_type: result?.data[j]?.card_type,
        });
      }
      setCardDetail(cardLists);
    } else {
      setCardDetail([]);
    }
  };

  const [paymentDetail, setPaymentDetail] = useState();

  useEffect(() => {
    if (paymentDetail?.credit_card_id) {
      setCradsDetail({ target: { value: paymentDetail?.credit_card_id } });
      // const data = cardDetail.find((item) => item.id === paymentDetail?.credit_card_id);
      // console.log(paymentDetail, cardDetail, data , 241)
    }
    if (bookingInfo?.bookingDetails?.advance_deposit_credit_card_id) {
      setDepositCradsDetails({
        target: {
          value: bookingInfo?.bookingDetails?.advance_deposit_credit_card_id,
        },
      });
    }
  }, [paymentDetail, cardDetail, bookingInfo?.bookingDetails]);

  // let now = new Date();
  // const crntTime =
  //   now.getHours() +
  //   ":" +
  //   now.getMinutes() +
  //   " " +
  //   (now.getHours() >= 12 ? "PM" : "AM");
  //setCurrentTime(crntTime);

  const idProofTypes = [
    { id: 1, value: "Passport" },
    { id: 2, value: "Driving License" },
  ];
  // const roomNumbers = [
  //   { id: 1, room_name: "Room No 1" },
  //   { id: 2, room_name: "Room No 2" },
  //   { id: 3, room_name: "Room No 3" },
  //   { id: 4, room_name: "Room No 4" },
  //   { id: 5, room_name: "Room No 5" },
  // ];

  const getAvailableRooms = async (catId, roomId, checkIn, checkOut) => {
    dispatch(getLoadingSuccess());

    const result = await fetchAvailableRoomsByCatAndRoom(
      catId,
      roomId,
      checkIn,
      checkOut,
    );
    if (result?.status === 200) {
      dispatch(getLoadingFailed());

      return result.data;
    } else {
      dispatch(getLoadingFailed());
      return [];
    }
  };

  // const init_room_info_obj = bookingInfo?.bookingItemsData?.map((item) => ({
  //   item_id: item?.id,
  //   room_category_name: item.roomCategoryDetail?.roomcategory_name,
  //   room_list: roomNumbers,
  //   room_number: 0,
  // }));

  // console.log(96, bookingInfo)

  const [roomList, setRoomList] = useState([]);

  useEffect(() => {
    const initAsync = async () => {
      const roomListDet = await Promise.all(
        bookingInfo.bookingItemsData.map(async (item) => {
          const response = await getAvailableRooms(
            item.room_category_id,
            item?.room_no,
            bookingInfo?.checkin_date,
            bookingInfo?.checkout_date,
          );
          return {
            item_id: item.id,
            room_category_name: item.roomCategoryDetail?.roomcategory_name,
            room_list: response,
            room_number: item?.roomDetail?.id,
            checkIn: bookingInfo?.checkin_date,
            checkOut: bookingInfo?.checkout_date,
            catId: item.room_category_id,
          };
        }),
      );
      setRoomList(roomListDet);
    };
    initAsync();

    getCradsDetail(bookingInfo?.user_id);
    setAgreement(bookingInfo?.agreementDetails);
    if (bookingInfo?.bookingPaymentDetails !== null) {
      setPaymentDetail((documentDetails) => ({
        ...documentDetails,
        bank_name: bookingInfo?.bookingPaymentDetails?.bank_name,
        booking_id: bookingInfo?.id,
        card_holder_name:
          bookingInfo?.bookingPaymentDetails?.cardDetail?.card_holder_name,
        card_number:
          bookingInfo?.bookingPaymentDetails?.cardDetail?.card_number,
        cheque_no: bookingInfo?.bookingPaymentDetails?.cheque_no,
        credit_card_id: bookingInfo?.bookingPaymentDetails?.credit_card_id,
      }));
    }

    setDocumentDetail((documentDetails) => ({
      ...documentDetails,
      id: bookingInfo?.id,
      user_id: bookingInfo?.user_id,
      name: bookingInfo?.userData.name,
      phone: bookingInfo?.userData?.mobile,
      phone_code: bookingInfo?.userData?.phone_code,
      email: bookingInfo?.userData?.email,
      id_number: bookingInfo?.userData?.idNumber,
      id_proof_type: bookingInfo?.userData?.id_proof_type,
      id_proof: "",
      image: "",
      address: bookingInfo?.userData?.address,
      tax_exempt: 0,
      tat_id: "",
      company_profile_name: bookingInfo?.userData?.userDetail?.company_name,
      corporate_id: "",
      country_id: bookingInfo?.userData?.userDetail?.country_id,
      state_id: bookingInfo?.userData?.userDetail?.state_id,
      city_id: bookingInfo?.userData?.userDetail?.city_id,
      postal_code: bookingInfo?.userData?.userDetail?.postal_code,
      userAgreementCopy: bookingInfo?.agreementDetails,
      company_name: bookingInfo?.hotelData?.company_name,
      company_phone: bookingInfo?.hotelData?.company_phone,
      iata_number: bookingInfo?.iata_number,
      payment_type: bookingInfo?.payment_type,
      hotel_id: bookingInfo?.hotelData?.id,
    }));
  }, [bookingInfo]);

  useEffect(() => {
    if (bookingInfo?.hotelData?.id) {
      getHotelDetail(bookingInfo?.hotelData?.id);
    }
  }, [bookingInfo?.hotelData?.id]);

  const initialState = {
    booking_id: bookingInfo?.id,
    check_in_time: moment().format("HH:mm"),
    is_early_check_in: false,
    id_proof: null,
    id_proof_img: bookingInfo?.bookingDetails?.id_proof,
    id_proof_type: bookingInfo?.bookingDetails?.id_proof_type,
    room_info: roomList,
    // room_info: init_room_info_obj,
  };
  // console.log("initialState", initialState);

  const handleUplodeDocument = async (type, file) => {
    // if (!file.name.match(/\.(jpg|jpeg|png|PNG|JPEG|JPG)$/)) {
    //   toast.error(t("Please Upload valid file Type PNG/JPG"));
    //   return;
    // }

    const validExtensions = ["png", "jpg", "jpeg"];
    const fileParts = file.name.split(".");
    const fileExtension = fileParts.pop().toLowerCase();

    // Reject files with multiple dots (e.g., "test.war.png")
    if (fileParts.length > 1 || !validExtensions.includes(fileExtension)) {
      toast.error(t("Please Upload a valid file Type (PNG/JPG)"));
      return;
    }

    if (type === 0) {
      toast.error(t("Please Select Id Proof Type"));
      return;
    }

    dispatch(getLoadingSuccess());
    const formData = new FormData();
    formData.append("booking_id", bookingInfo?.id);
    formData.append("id_proof", file);
    formData.append("id_proof_type", type);

    const result = await createRecord(formData, ApiEndPoints.UPLOAD_ID_PROOF);
    if (result?.status === 200) {
      toast.success(t(result.message));
      setDocumentDetail((documentDetails) => ({
        ...documentDetails,
        id_proof: file,
        id_proof_type: type,
      }));
      await fetchList(ApiEndPoints.GET_BOOKING_DETAILS + `/${bookingInfo?.id}`)
        .then((result) => {
          setBookingInfo({
            ...bookingInfo,
            agreementDetails: result?.data?.agreementDetails,
          });
          dispatch(getLoadingFailed());
        })
        .catch((err) => dispatch(getLoadingFailed()));
      // props.getReservationDetails();
      // dispatch(getLoadingFailed());
    } else {
      toast.error(t(result.message));
      dispatch(getLoadingFailed());
    }
  };

  // const [selectedRoom, setSelectedRoom] = useState([]);

  const handleSelectRoom = async (e, ind, data, setFieldValue) => {
    const data1 = roomList?.find((item, index2) => index2 === ind);
    // data1.room_number = e.target.value

    const data2 = roomList.filter(
      (item, index) => item.item_id !== data1.item_id,
    );

    // console.log(roomList,ind, data1, data2, 890);
    if (data2.length === 0) {
      data1.room_number = e.target.value;
      setFieldValue(`room_info.${ind}.room_number`, e.target.value);
    } else {
      const data3 = data2.filter((item, index) => item.catId === data1.catId);
      const selectedRooms = [];
      for (let j in data3) {
        if (data3[j].room_number !== 0 && data3[j].room_number !== undefined) {
          selectedRooms.push(data3[j].room_number);
        } else {
          data1.room_number = e.target.value;
          setFieldValue(`room_info.${ind}.room_number`, e.target.value);
          // return;
        }
        // setSelectedRoom(selectedRooms);
      }
      // console.log(data3,selectedRooms, 897)

      if (selectedRooms.length === 0) {
        data1.room_number = e.target.value;
        setFieldValue(`room_info.${ind}.room_number`, e.target.value);
      } else {
        for (let t in selectedRooms) {
          if (selectedRooms[t] === e.target.value) {
            data1.room_number = 0;
            setFieldValue(`room_info.${ind}.room_number`, 0);
            toast.error(t("This Room is Already selected"));
            return;
          } else {
            data1.room_number = e.target.value;
            setFieldValue(`room_info.${ind}.room_number`, e.target.value);
          }
        }
      }
    }
  };

  const [agreement, setAgreement] = useState(null);

  // console.log(agreement != null , 227)
  const [documentDetail, setDocumentDetail] = useState({
    id: "",
    user_id: "",
    name: "",
    phone: "",
    phone_code: "+1",
    email: "",
    id_number: "",
    id_proof_type: "",
    id_proof: "",
    image: "",
    address: "",
    tax_exempt: 0,
    tat_id: "",
    iata_number: "",
    company_profile_name: "",
    corporate_id: 0,
    country_id: "",
    state_id: "",
    city_id: "",
    postal_code: "",
    payment_type: "",
    documentDetail: null,
    company_name: "",
    company_phone: "",
    hotel_id: "",
  });

  const handleUplodePdf = async (e) => {
    dispatch(getLoadingSuccess());
    const formData = new FormData();
    formData.append("agreement_copy", e.target.files[0]);
    formData.append("user_id", documentDetail.user_id);
    formData.append("booking_id", bookingInfo?.id);
    formData.append("isSigned", 1);
    const result = await createRecord(formData, ApiEndPoints.CREATE_AGREEMENT);
    if (result?.status === 200) {
      toast.success(t(result.message));
      await fetchList(ApiEndPoints.GET_BOOKING_DETAILS + `/${bookingInfo?.id}`)
        .then((result) => {
          setBookingInfo({
            ...bookingInfo,
            agreementDetails: result?.data?.agreementDetails,
          });
          dispatch(getLoadingFailed());
        })
        .catch((err) => dispatch(getLoadingFailed()));
      // getReservationDetails();
    } else {
      toast.error(t(result.message));
      dispatch(getLoadingFailed());
    }
  };

  // console.log(bookingInfo,272)

  const [openSendSmsEmailDialog, setOpenSendSmsEmailDialog] = useState(false);

  const [checkInValues, setCheckInValues] = useState({});
  const [isCapture, setIsCapture] = useState(false);

  const handleOpenSmsEmail = (values, capture) => {
    setCheckInValues(values);
    setIsCapture(capture);
    setOpenSendSmsEmailDialog(true);
  };

  // console.log(bookingInfo?.payment_type, 1044);

  const handleMakePaymentCapture = async (values, send_sms) => {
    if (bookingInfo?.payment_type === 4) {
      toast.error(t("This booking has direct bill payment method"));
      return;
    }

    if (bookingInfo?.payment_type === 2 && card?.id === 0 && !suOn) {
      toast.error(t("Please Select Card or Add Card"));
      return;
    }
    dispatch(getLoadingSuccess());

    const amountResult = await getRecord(
      values?.booking_id,
      ApiEndPoints.CHECK_AMOUNT_CAPTURE_AND_AUTHORISE,
    );
    if (amountResult?.status === 200) {
      // console.log(+bookingInfo.final_amount - +amountResult?.data?.amount,advancePaymentAuthorise?.amount, 1695)
      if (
        +(+bookingInfo.final_amount - +amountResult?.data?.amount).toFixed(2) >
        0
      ) {
        let bodyFormData = {
          booking_id: values?.booking_id,
          credit_card_id: bookingInfo?.payment_type === 2 ? card?.id : "0",
          amount: +bookingInfo.final_amount - +amountResult?.data?.amount,
          description: "Check in Confirm & Charge",
          user_id: documentDetail?.user_id,
          payment_type: bookingInfo?.payment_type,
          card_present: 0,
          // device_id: selectPinpadDevices,
          // su_token: !card_present && suOn ? suToken : ""
        };

        if (suOn) {
          bodyFormData.su_token = suToken;
        }

        const result = await createRecord(
          bodyFormData,
          ApiEndPoints.PAYMENT_CARD_CAPTURE,
        );
        if (result.status == 200) {
          // dispatch(getLoadingFailed());
          refreshData();
          toast.success(result?.message);
          handleSubmit(values, send_sms);
        } else {
          toast.error(result?.message);
          setOpenSendSmsEmailDialog(false);
          dispatch(getLoadingFailed());
        }
      } else if (
        +(+bookingInfo.final_amount - +amountResult?.data?.amount).toFixed(
          2,
        ) === 0
      ) {
        // toast.success("Payment is already captured!");
        handleSubmit(values, send_sms);
      } else {
        dispatch(getLoadingFailed());
        toast.error(
          `${t("Sorry,Your Remaining Amount is")} ${(
            +bookingInfo.final_amount - +amountResult?.data?.amount
          ).toFixed(2)}`,
        );
      }
    } else {
      dispatch(getLoadingFailed());
      toast.error(amountResult?.message);
    }
  };

  const handleSubmit = async (values, send_sms) => {
    setOpenSendSmsEmailDialog(false);
    let valueArr = values.room_info.map(function (item) {
      return item.room_number;
    });
    let isDuplicate = valueArr.some(function (item, idx) {
      return valueArr.indexOf(item) != idx;
    });

    for (let j in roomList) {
      if (roomList[j].room_number === 0) {
        toast.error(t("To confirm the Check In, you must select Room Number"));
        dispatch(getLoadingFailed());

        return;
      }
    }

    if (
      !depositCard?.card_passed &&
      // bookingInfo?.payment_type !== 1 &&
      // bookingInfo?.payment_type !== 4 &&
      hotelSetting?.is_deposit_card_mandatory === 1
    ) {
      toast.error(t("Please Add Deposit Card!"));
      dispatch(getLoadingFailed());

      return;
    }

    if (
      ![1, 2]?.includes(values?.id_proof_type) &&
      hotelSetting?.is_agreement_mandatory === 1
    ) {
      toast.error(t("Please Select id proof type!"));
      dispatch(getLoadingFailed());

      return;
    }

    if (agreement === null && hotelSetting?.is_agreement_mandatory === 1) {
      toast.error(t("Please Sign Agreement!"));
      dispatch(getLoadingFailed());

      return;
    }

    if (
      values?.id_proof_img === null &&
      hotelSetting?.is_agreement_mandatory === 1
    ) {
      toast.error(t("Please Upload Id Proof!"));
      dispatch(getLoadingFailed());

      return;
    }
    // setLoading(false);
    if (isDuplicate) {
      toast.error(t("Same room numbers are not allowed."));
      dispatch(getLoadingFailed());
      return;
    } else {
      let bodyFormData = new FormData();
      bodyFormData.append("booking_id", values.booking_id);
      bodyFormData.append("check_in_time", values.check_in_time);
      // bodyFormData.append("room_number", values.room_number);
      bodyFormData.append(
        "is_early_check_in",
        values.is_early_check_in ? 1 : 0,
      );
      bodyFormData.append("id_proof", values.id_proof);
      bodyFormData.append("id_proof_type", values.id_proof_type);
      bodyFormData.append("send_sms", send_sms);

      values.room_info.forEach((element, key) => {
        bodyFormData.append(`room_info[${key}][item_id]`, element.item_id);
        bodyFormData.append(`room_info[${key}][room_id]`, element.room_number);
      });
      dispatch(getLoadingSuccess());
      const result = await makeCheckIn(bodyFormData);
      if (result?.status === 200) {
        handleDialogClose1();
        refreshData();
        dispatch(getLoadingFailed());
        toast.success(t(result.message));
      } else {
        dispatch(getLoadingFailed());
        toast.error(t(result.message));
      }
    }
  };
  const renderError = (message) => (
    <p style={{ color: "red" }} className="help is-danger">
      {message}
    </p>
  );

  const handleCheckinSubmit = async (sendSms) => {
    if (isCapture) {
      handleMakePaymentCapture(checkInValues, sendSms);
    } else {
      handleSubmit(checkInValues, sendSms);
    }
  };

  const [agreementCopyPrint, setAgreementCopyPrint] = useState(false);
  const promiseResolveRef = useRef(null);
  const [templateList, setTemplateList] = useState({
    agreement_acceptance: "",
    general_release: "",
    credit_card_authorization: "",
    id: 0,
  });
  const [printLoading, setPrintLoading] = useState(false);

  useEffect(() => {
    if (agreementCopyPrint && promiseResolveRef.current) {
      promiseResolveRef.current();
    }
  }, [agreementCopyPrint]);

  const getTemplateDetail = async (hotel_id) => {
    const userHotelID = localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))["hotel_id"]
      : 0;
    setPrintLoading(true);

    const result = await fetchList(
      ApiEndPoints.GET_AGREEMENT_TEMPLATE + `?hotel_id=${userHotelID}`,
    );
    if (result?.status === 200) {
      setTemplateList({
        agreement_acceptance: result?.data?.agreement_acceptance,
        general_release: result?.data?.general_release,
        credit_card_authorization: result?.data?.credit_card_authorization,
        id: result?.data?.id,
      });
      setPrintLoading(false);
      if (promiseResolveRef.current) {
        setAgreementCopyPrint(true);
      }
    } else {
      setPrintLoading(false);
      setTemplateList({
        agreement_acceptance: "",
        general_release: "",
        credit_card_authorization: "",
        id: 0,
      });
    }
  };

  // console.log(selectedCard,selectedDepoCard,initialState?.room_info ,1086)

  return (
    <div className="p-1" style={{ overflow: "scroll" }}>
      {printLoading && <Loader />}
      <div
        className="d-flex align-items-center justify-content-between"
        style={{
          width: "100%",
          minHeight: "50px",
          margin: "auto",
          marginBottom: "0px",
        }}
      >
        {/* Left side */}
        <div
          id="font-600"
          style={{
            padding: "10px",
          }}
        >
          {t("Booking")}
        </div>

        {/* Right side */}
        {hotelSetting?.is_hotel_smart_lock_enabled === 1 && (
          <div
            className="d-flex align-items-center"
            style={{
              padding: "10px",
            }}
          >
            <Typography
              id="font-600"
              style={{
                marginRight: "8px",
                fontSize: "16px",
              }}
            >
              {t("Lock Device Status")}:
            </Typography>

            <Typography
              style={{
                color:
                  lockStatus === null
                    ? "inherit"
                    : lockStatus === 0 || lockStatus === 1
                      ? "inherit"
                      : "red",
              }}
            >
              {lockStatus === null
                ? "-"
                : lockStatus === 0
                  ? t("Locked")
                  : lockStatus === 1
                    ? t("Unlocked")
                    : lockErrorMsg
                      ? t(lockErrorMsg)
                      : t("Unknown")}
            </Typography>
          </div>
        )}
      </div>
      {/* formik start */}
      {initialState && initialState?.room_info?.length > 0 ? (
        <>
          <Formik
            initialValues={initialState}
            onSubmit={async (values) => handleOpenSmsEmail(values, false)}
            validateOnBlur={false}
            validationSchema={() => CheckInValidations(t)}
            validateOnChange={true}
            enableReinitialize={true}
          >
            {/* {(errors, touched, props: any) => { */}
            {(props) => {
              const { handleSubmit } = props;
              return (
                <form onSubmit={handleSubmit}>
                  <div
                    className="d-flex"
                    style={{
                      width: "100%",
                      minHeight: "100px",
                      border: "1px solid gray",
                      margin: "auto",
                      flexWrap: "wrap",
                      marginBottom: "10px",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        // width: "100%",
                        padding: "10px",
                        alignItems: "center",
                      }}
                      className="d-flex"
                    >
                      <div>
                        <img
                          style={{ width: "50px", height: "50px" }}
                          src={bell}
                          alt="bell"
                        />
                      </div>
                      <div className="d-block">
                        <h6>{t("Confirmation#")}</h6>
                        <h6>#{String(bookingInfo?.id).padStart(6, "0")}</h6>
                      </div>
                    </div>
                    <div
                      style={{
                        // width: "100%",
                        padding: "10px",
                        alignItems: "center",
                      }}
                      className="d-flex"
                    >
                      <div>
                        <img
                          style={{ width: "50px", height: "50px" }}
                          src={bell}
                          alt="bell"
                        />
                      </div>
                      <div className="d-block">
                        <h6>{t("Adults")}</h6>
                        <h6>{bookingInfo?.no_of_adults}</h6>
                      </div>
                      <div className="d-block ml-3">
                        <h6>{t("Children")}</h6>
                        <h6>{bookingInfo?.no_of_children}</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      width: "100%",
                      minHeight: "120px",
                      border: "1px solid gray",
                      margin: "auto",
                      flexWrap: "wrap",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        // width: "55%",
                        padding: "10px",
                        alignItems: "center",
                      }}
                      className="d-block"
                    >
                      <h6>{t("Check In Time")}</h6>
                      <h6>
                        {moment(bookingInfo?.checkin_date, "YYYY-MM-DD").format(
                          "MM/DD/YYYY",
                        )}
                      </h6>
                      <Grid container spacing={2} alignItems="end">
                        <Grid item>
                          <Field
                            label=""
                            name="check_in_time"
                            type="time"
                            // defaultoption
                            component={FormikInput1}
                          />
                          <ErrorMessage
                            name="check_in_time"
                            render={renderError}
                          />
                        </Grid>
                      </Grid>
                    </div>
                    {/* <div
          style={{ width: "55%", padding: "10px", alignItems: "center" }}
          className="d-block"
        >
          <h6>Check Out Time</h6>
          <h6>{props.editedData.checkout_date}</h6>
          <Formik>
            <Grid container spacing={2} alignItems="end">
              <Grid item lg={8.1}>
                <Field
                  label=""
                  name="roleId"
                  id="roleId"
                  defaultOption
                  options={data?.map((role) => ({
                    title: role.title,
                    value: role.value,
                  }))}
                  component={FormikSelect}
                />
              </Grid>
            </Grid>
          </Formik>
        </div> */}
                  </div>
                  <Grid
                    container
                    rowSpacing={2}
                    // className="d-flex"
                    style={{
                      width: "100%",
                      minHeight: "100px",
                      margin: "auto",
                      marginTop: "10px",
                    }}
                  >
                    <Grid item xs={12} md={6}>
                      <h6>{t("ID Proof Type")}</h6>
                      <Grid container spacing={2} alignItems="end">
                        <Grid item md={8} xs={12}>
                          <Field
                            label=""
                            name="id_proof_type"
                            defaultOption
                            options={idProofTypes?.map((type) => ({
                              title: type.value,
                              value: type.id,
                            }))}
                            fullWidth
                            component={FormikSelect}
                          />
                          {props.errors.id_proof_type &&
                          props.touched.id_proof_type ? (
                            <div style={{ color: "red" }}>
                              {props.errors.id_proof_type}
                            </div>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <h6>{t("ID Proof Image")}</h6>

                      <Grid container spacing={2} alignItems="end">
                        <Grid item md={8} xs={12}>
                          <FormControl
                            fullWidth
                            //   className={controlClassName}
                            //   sx={sx}
                          >
                            <TextField
                              // margin="normal"
                              // required
                              fullWidth
                              name="id_proof"
                              type="file"
                              onChange={(event) => {
                                props.setFieldValue(
                                  "id_proof",
                                  event.currentTarget.files[0],
                                );
                                props.setFieldValue(
                                  "id_proof_img",
                                  URL.createObjectURL(
                                    event.currentTarget.files[0],
                                  ),
                                );
                                handleUplodeDocument(
                                  props.values?.id_proof_type,
                                  event.currentTarget.files[0],
                                );
                              }}
                              onClick={(e) => {
                                e.target.value = null;
                              }}
                            />
                            <ErrorMessage
                              name="id_proof"
                              render={renderError}
                            />
                          </FormControl>
                        </Grid>
                        <Grid
                          item
                          // md={4}
                          // xs={12}
                          // direction="row"
                          justifyContent="end"
                          alignItems="end"
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "end",
                          }}
                        >
                          {props.values.id_proof_img && (
                            <img
                              style={{
                                width: "50px",
                                height: "50px",
                                marginLeft: "20px",
                                cursor: "pointer",
                              }}
                              // onClick={() =>
                              // window.open(props.values.id_proof_img)
                              // }
                              src={props.values.id_proof_img}
                              alt={props.values.id_proof_img}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <div
                    style={{
                      width: "100%",
                      minHeight: "70px",
                      margin: "10px auto",
                      justifyContent: "end",
                      paddingInline: "5px",
                    }}
                  >
                    <Grid item xs={12} md={8}>
                      <Typography
                        style={{
                          marginBottom: "11px",
                          color: "#1E1E1E",
                          fontSize: "16px",
                          fontWeight: "500",
                        }}
                        variant="h4"
                      >
                        {t("Agreement Copy")}
                      </Typography>
                      {/* <Typography variant="subtitle1"> */}
                      {agreement == null ? (
                        <Grid container spacing={2}>
                          <Grid item lg={6} md={6}>
                            <ReactToPrint
                              onBeforeGetContent={() => {
                                return new Promise((resolve) => {
                                  promiseResolveRef.current = resolve;
                                  getTemplateDetail();
                                });
                              }}
                              trigger={() => {
                                return (
                                  <Button
                                    variant="outlined"
                                    style={{
                                      justifyContent: "center",
                                      height: "fit-content",
                                      textTransform: "capitalize",
                                      fontSize: "14px",
                                      width: "100%",
                                    }}
                                  >
                                    {t("Download Agreement Copy")}
                                  </Button>
                                );
                              }}
                              onAfterPrint={() => {
                                promiseResolveRef.current = null;
                                setAgreementCopyPrint(false);
                              }}
                              content={() => componentRef.current}
                            />

                            <div style={{ display: "none" }}>
                              <PrintAgreement
                                ref={componentRef}
                                paymentDetail={paymentDetail}
                                signature={null}
                                documentDetail={documentDetail}
                                templateList={templateList}

                                // componentRef={componentRef}
                              />
                            </div>
                          </Grid>
                          <Grid item lg={6} md={6}>
                            <Button
                              // variant="contained"
                              variant="outlined"
                              component="label"
                              style={{
                                justifyContent: "center",
                                height: "fit-content",
                                textTransform: "capitalize",
                                fontSize: "14px",
                                width: "100%",
                                textAlign: "center",
                                // background: "rgb(117, 116, 116)",
                              }}
                            >
                              {t("Upload Agreement")}
                              <input
                                onChange={handleUplodePdf}
                                type="file"
                                accept="application/pdf"
                                hidden
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      ) : (
                        <a
                          href={agreement?.agreement_copy}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {t("Agreement")}
                        </a>
                      )}
                      {/* </Typography> */}
                    </Grid>
                  </div>
                  <div
                    className="d-flex"
                    style={{
                      width: "100%",
                      // minHeight: "50px",
                      margin: "auto",
                    }}
                  >
                    <div
                      id="font-700"
                      style={{
                        width: "75%",
                        padding: "5px",
                        alignItems: "center",
                        color: "#1E1E1E",
                        fontSize: "16px",
                      }}
                      className="d-flex"
                    >
                      {t("Room Details")}
                    </div>
                  </div>
                  {/* here start room choose */}
                  <div
                    className="d-flex"
                    style={{
                      width: "100%",
                      minHeight: "50px",
                      margin: "auto",
                      marginBottom: "10px",
                    }}
                  >
                    <Grid container>
                      <FieldArray name="room_info">
                        {({ push, remove }) => (
                          <Grid container sx={{ marginTop: 2 }}>
                            <TableContainer>
                              <Table
                                // borderAxis="both"
                                sx={{
                                  borderCollapse: "collapse",
                                }}
                                // aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      id="font-600"
                                      style={{ minWidth: "140px" }}
                                    >
                                      {t("Category Name")}
                                    </TableCell>
                                    <TableCell
                                      id="font-600"
                                      style={{
                                        minWidth: "250px",
                                        borderRight: "0px",
                                      }}
                                    >
                                      {t("Room")}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {props.values.room_info?.map((_, index) => (
                                    <TableRow
                                      key={index}
                                      // sx={{
                                      //   "&:last-child td": {
                                      //     border: 0,
                                      //   },
                                      // }}
                                    >
                                      <TableCell
                                      // style={{
                                      //   border: "1px solid #B4ADAD",
                                      // }}
                                      >
                                        <Grid item lg={12}>
                                          <Typography>
                                            {
                                              props.values.room_info[
                                                `${index}`
                                              ]["room_category_name"]
                                            }
                                          </Typography>
                                        </Grid>
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          borderRight: "0px",
                                        }}
                                      >
                                        <Grid item lg={12}>
                                          <Field
                                            label={t("Room Type")}
                                            name={`room_info.${index}.room_number`}
                                            onChange={(e) => {
                                              handleSelectRoom(
                                                e,
                                                index,
                                                props.values.room_info[
                                                  `${index}`
                                                ],
                                                props.setFieldValue,
                                              );
                                            }}
                                            defaultOption
                                            options={props.values.room_info[
                                              `${index}`
                                            ].room_list?.map((room) => ({
                                              title: room?.room_name,
                                              value: room?.id,
                                            }))}
                                            component={FormikSelect}
                                          />
                                          {/* <ErrorMessage
                                              name={`room_info.${index}.room_number`}
                                              component={ShowInputError}
                                            /> */}
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        )}
                      </FieldArray>
                    </Grid>
                  </div>
                  {/* su Token */}

                  <div className="pt-2">
                    <Grid container rowSpacing={1} alignItems="flex-start">
                      {+bookingInfo?.booking_source === 3 && (
                        <Grid item container xs={12}>
                          <Grid item>
                            <Typography
                              id="font-600"
                              style={{
                                // marginLeft: "25px",
                                marginBottom: "11px",
                                color: "#1E1E1E",
                                fontSize: "16px",
                                fontWeight: "500",
                              }}
                              variant="h4"
                            >
                              {t("Virtual card token :")}
                            </Typography>
                          </Grid>
                          <div
                            className="d-flex align-items-center"
                            style={{ marginTop: "-8px" }}
                          >
                            {suToken && (
                              <FormControlLabel
                                className="ml-1"
                                control={
                                  <IOSSwitch
                                    checked={suOn}
                                    onChange={(e) => handleSuOn(e)}
                                  />
                                }
                                label={""}
                              />
                            )}
                            <Typography
                              id={"color-black"}
                              className="d-flex align-items-center"
                              variant="subtitle1"
                            >
                              {suToken &&
                                String(
                                  suToken?.substr(suToken?.length - 4),
                                ).padStart(12, "x")}
                            </Typography>
                          </div>
                        </Grid>
                      )}
                    </Grid>
                  </div>

                  {/* change Primary Card */}
                  {bookingInfo?.payment_type == 2 && !suOn && (
                    <div
                      className="py-2"
                      // style={{
                      //   border: "1px solid gray",
                      // }}
                    >
                      {/* <Grid container spacing={2} alignItems="flex-start"> */}
                      <>
                        <Typography
                          id="font-600"
                          style={{
                            // marginLeft: "25px",
                            marginBottom: "11px",
                            color: "#1E1E1E",
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                          variant="h4"
                        >
                          {t("Change Primary Card")}
                        </Typography>
                        <div
                          className="p-2"
                          style={{
                            border: "1px solid gray",
                          }}
                        >
                          <Grid
                            container
                            spacing={2}
                            style={{
                              width: "100%",
                              // marginTop: "20px",
                              // paddingBottom: "16px",
                              // height: "220px",
                            }}
                          >
                            <Grid item lg={2} md={4} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "rgb(30, 30, 30)",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Select Card")}
                              </Typography>
                              <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                  {t("Select Card")}
                                </InputLabel>
                                <Select
                                  // style={{ width: '200px' }}
                                  labelId="demo-simple-select-label"
                                  id="demo-simple-select"
                                  onChange={(e) => setCradsDetail(e)}
                                  value={selectedCard}
                                  // value={card?.id}
                                  // value={cancelPolicy}
                                  disabled={
                                    !(
                                      bookingInfo?.booking_status == 2 &&
                                      bookingInfo?.bookingPaymentSummary?.filter(
                                        (item) => item?.summary_type === 1,
                                      )?.length === 0
                                    )
                                  }
                                  label={t("Select Card")}
                                >
                                  <MenuItem value={0}>{t("Add Card")}</MenuItem>
                                  {cardDetail.map((item) => (
                                    <MenuItem key={item?.id} value={item.id}>
                                      {item.card_holder_name}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item lg={3} md={4} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "rgb(30, 30, 30)",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Card Holder Name")}
                              </Typography>
                              <TextField
                                value={card?.card_holder_name}
                                disabled={
                                  !(card?.id == 0 || Number.isNaN(card?.id))
                                }
                                placeholder={t("Card Holder Name")}
                                onChange={(e) => handeleCardChange(e)}
                                name="card_holder_name"
                                id="group_name"
                              />
                            </Grid>
                            <Grid item lg={2.7} md={4} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "rgb(30, 30, 30)",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Card Number")}
                              </Typography>
                              <TextField
                                value={card?.card_number}
                                placeholder={t("Card Number")}
                                disabled={
                                  !(card?.id == 0 || Number.isNaN(card?.id))
                                }
                                // type={
                                //   card?.id == 0 || Number.isNaN(card?.id)
                                //     ? "number"
                                //     : ""
                                // }
                                type="text" // Change from "number" to "text"
                                inputMode="numeric" // Ensures only numbers show up in the keyboard
                                name="card_number"
                                onChange={(e) => {
                                  const value = e.target.value.replaceAll(
                                    /\D/g,
                                    "",
                                  ); // Remove non-numeric characters
                                  if (value?.length > 16) {
                                    return;
                                  }
                                  handeleCardChange({
                                    target: { name: e.target.name, value },
                                  });
                                }}
                                id="group_name"
                              />
                            </Grid>
                            <Grid item lg={1} md={4} xs={12}>
                              <Typography
                                id="font-600"
                                style={{
                                  marginBottom: "11px",
                                  color: "rgb(30, 30, 30)",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {t("Expiry")}
                              </Typography>
                              <FormControl fullWidth>
                                <InputLabel title={"Month"}>{"MM"}</InputLabel>
                                <Select
                                  name="mm"
                                  input={<OutlinedInput label="MM" />}
                                  label="Month"
                                  disabled={
                                    !(card?.id == 0 || Number.isNaN(card?.id))
                                  }
                                  onChange={(e) => handeleCardChange(e)}
                                  value={card?.mm + ""}
                                >
                                  <MenuItem value={""}>{t("MM")}</MenuItem>
                                  {month.map((item) => (
                                    <MenuItem key={item} value={item}>
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            <Grid item lg={1.3} md={4} xs={12}>
                              <Typography
                                style={{
                                  marginBottom: "35px",
                                  color: "rgb(30, 30, 30)",
                                  fontSize: "16px",
                                  lineHeight: "24px",
                                }}
                              >
                                {" "}
                              </Typography>

                              <FormControl fullWidth>
                                <InputLabel title={"Year"}>{"YYYY"}</InputLabel>
                                <Select
                                  name="yyy"
                                  input={<OutlinedInput label="YYYY" />}
                                  label={t("Year")}
                                  disabled={
                                    !(card?.id == 0 || Number.isNaN(card?.id))
                                  }
                                  onChange={(e) => handeleCardChange(e)}
                                  value={card?.yyy + ""}
                                >
                                  <MenuItem value={""}>{t("YYYY")}</MenuItem>
                                  {yearList.map((item) => (
                                    <MenuItem key={item} value={item}>
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                            {card?.id == 0 || Number.isNaN(card?.id) ? (
                              <Grid item lg={1.8} md={4} xs={12}>
                                <Typography
                                  id="font-600"
                                  style={{
                                    marginBottom: "11px",
                                    color: "rgb(30, 30, 30)",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                  }}
                                >
                                  {t("Cvv")}
                                </Typography>

                                <TextField
                                  value={card?.cvv}
                                  disabled={
                                    !(card?.id == 0 || Number.isNaN(card?.id))
                                  }
                                  onChange={(e) => handeleCardChange(e)}
                                  placeholder={t("CVV")}
                                  name="cvv"
                                  id="cvv"
                                  type="number"
                                />
                              </Grid>
                            ) : (
                              <Grid item lg={1.3} md={4} xs={12}>
                                <Typography
                                  id="font-600"
                                  style={{
                                    marginBottom: "11px",
                                    color: "rgb(30, 30, 30)",
                                    fontSize: "16px",
                                    lineHeight: "24px",
                                  }}
                                >
                                  {t("Card Type")}
                                </Typography>
                                <TextField
                                  value={card?.card_type}
                                  disabled={
                                    !(card?.id == 0 || Number.isNaN(card?.id))
                                  }
                                  // onChange={(e) => handeleCardChange(e)}
                                  placeholder={t("Card Type")}
                                  name="Card Type"
                                  id="Card Type"
                                />
                              </Grid>
                            )}
                            {card?.id !== paymentDetail?.credit_card_id &&
                            card?.id !== 0 ? (
                              <Grid item lg={4} md={4} xs={12}>
                                <Button
                                  variant="contained"
                                  onClick={handleChangePrimaryCard}
                                  title="Cancel"
                                  className="comman-button"
                                  // style={{
                                  //   width: "fit-content",
                                  //   height: "47px",
                                  //   // marginTop: "10px",
                                  // }}
                                >
                                  {t("Make Primary Card")}
                                </Button>
                              </Grid>
                            ) : (
                              ""
                            )}
                            {card?.id == 0 || Number.isNaN(card?.id) ? (
                              <Grid item lg={1.5} md={4} xs={12}>
                                <Button
                                  variant="contained"
                                  onClick={addCardDetail}
                                  title="Cancel"
                                  className="comman-button"
                                  // style={{
                                  //   width: "150px",
                                  //   height: "47px",
                                  //   // marginTop: `${!onlyCard?'-10px':'36px'}`,
                                  // }}
                                >
                                  {t("Add & Verify")}
                                </Button>
                              </Grid>
                            ) : (
                              ""
                            )}
                          </Grid>
                        </div>
                      </>
                      {/* </Grid> */}
                    </div>
                  )}

                  {/* change Deposit Card */}

                  <div className="py-2">
                    {/* <Grid container spacing={2} alignItems="flex-start"> */}

                    <Typography
                      id="font-600"
                      style={{
                        // marginLeft: "25px",
                        marginBottom: "11px",
                        color: "#1E1E1E",
                        fontSize: "16px",
                        fontWeight: "500",
                      }}
                      variant="h4"
                    >
                      {t("Change Deposit Card")}
                    </Typography>
                    <div
                      className="p-2"
                      style={{
                        border: "1px solid gray",
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                        style={{
                          width: "100%",

                          // paddingBottom: "16px",
                          // marginBottom: "25px",
                          // height: "fit-content",
                        }}
                      >
                        <Grid item lg={2} md={4} xs={12}>
                          <Typography
                            id="font-600"
                            style={{
                              marginBottom: "11px",
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          >
                            {t("Select Card")}
                          </Typography>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              {t("Select Card")}
                            </InputLabel>
                            <Select
                              // style={{ width: '200px' }}
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              onChange={(e) => setDepositCradsDetails(e)}
                              value={selectedDepoCard}
                              // value={cancelPolicy}
                              label={t("Select Card")}
                            >
                              <MenuItem value={0}>{t("Add Card")}</MenuItem>
                              {cardDetail.map((item) => (
                                <MenuItem key={item?.id} value={item.id}>
                                  {item.card_holder_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={3} md={4} xs={12}>
                          <Typography
                            id="font-600"
                            style={{
                              marginBottom: "11px",
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          >
                            {t("Card Holder Name")}
                          </Typography>
                          <TextField
                            value={depositCard?.card_holder_name}
                            disabled={
                              !(
                                depositCard?.id == 0 ||
                                Number.isNaN(depositCard?.id)
                              )
                            }
                            placeholder={t("Card Holder Name")}
                            onChange={(e) => handleDepositCardChange(e)}
                            name="card_holder_name"
                            id="group_name"
                          />
                        </Grid>
                        <Grid item lg={2.7} md={4} xs={12}>
                          <Typography
                            id="font-600"
                            style={{
                              marginBottom: "11px",
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          >
                            {t("Card Number")}
                          </Typography>
                          <TextField
                            value={depositCard?.card_number}
                            placeholder={t("Card Number")}
                            disabled={
                              !(
                                depositCard?.id == 0 ||
                                Number.isNaN(depositCard?.id)
                              )
                            }
                            type="text" // Change from "number" to "text"
                            inputMode="numeric" // Ensures only numbers show up in the keyboard
                            name="card_number"
                            onChange={(e) => {
                              const value = e.target.value.replaceAll(
                                /\D/g,
                                "",
                              ); // Remove non-numeric characters
                              if (value?.length > 16) {
                                return;
                              }
                              handleDepositCardChange({
                                target: { name: e.target.name, value },
                              });
                            }}
                            id="group_name"
                          />
                        </Grid>
                        <Grid item lg={1} md={4} xs={12}>
                          <Typography
                            id="font-600"
                            style={{
                              marginBottom: "11px",
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          >
                            {t("Expiry")}
                          </Typography>

                          <FormControl fullWidth>
                            <InputLabel title={"Month"}>{"MM"}</InputLabel>
                            <Select
                              name="mm"
                              input={<OutlinedInput label="MM" />}
                              label="Month"
                              disabled={
                                !(
                                  depositCard?.id == 0 ||
                                  Number.isNaN(depositCard?.id)
                                )
                              }
                              onChange={(e) => handleDepositCardChange(e)}
                              value={depositCard?.mm + ""}
                            >
                              <MenuItem value={""}>{t("MM")}</MenuItem>
                              {month.map((item) => (
                                <MenuItem key={item} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={1.3} md={4} xs={12}>
                          <Typography
                            sx={{
                              marginBottom: { xs: "0", md: "35px" },
                              color: "rgb(30, 30, 30)",
                              fontSize: "16px",
                              lineHeight: "24px",
                            }}
                          >
                            {" "}
                          </Typography>

                          <FormControl fullWidth>
                            <InputLabel title={"Year"}>{"YYYY"}</InputLabel>
                            <Select
                              name="yyy"
                              input={<OutlinedInput label="YYYY" />}
                              label="Year"
                              disabled={
                                !(
                                  depositCard?.id == 0 ||
                                  Number.isNaN(depositCard?.id)
                                )
                              }
                              onChange={(e) => handleDepositCardChange(e)}
                              value={depositCard?.yyy + ""}
                            >
                              <MenuItem value={""}>{t("YYYY")}</MenuItem>
                              {yearList.map((item) => (
                                <MenuItem key={item} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        {depositCard?.id == 0 ||
                        Number.isNaN(depositCard?.id) ? (
                          <Grid item lg={1.8} md={4} xs={12}>
                            <Typography
                              id="font-600"
                              style={{
                                marginBottom: "11px",
                                color: "rgb(30, 30, 30)",
                                fontSize: "16px",
                                lineHeight: "24px",
                              }}
                            >
                              {t("Cvv")}
                            </Typography>
                            <TextField
                              value={depositCard?.cvv}
                              disabled={
                                !(
                                  depositCard?.id == 0 ||
                                  Number.isNaN(depositCard?.id)
                                )
                              }
                              onChange={(e) => handleDepositCardChange(e)}
                              placeholder={t("CVV")}
                              name="cvv"
                              id="cvv"
                              type="number"
                            />
                          </Grid>
                        ) : (
                          <Grid item lg={1.3} md={4} xs={12}>
                            <Typography
                              id="font-600"
                              style={{
                                marginBottom: "11px",
                                color: "rgb(30, 30, 30)",
                                fontSize: "16px",
                                lineHeight: "24px",
                              }}
                            >
                              {t("Card Type")}
                            </Typography>
                            <TextField
                              value={depositCard?.card_type}
                              disabled={
                                !(
                                  depositCard?.id == 0 ||
                                  Number.isNaN(depositCard?.id)
                                )
                              }
                              // onChange={(e) => handeleCardChange(e)}
                              placeholder={t("Card Type")}
                              name="Card Type"
                              id="Card Type"
                            />
                          </Grid>
                        )}
                        {depositCard?.id !==
                          bookingInfo?.bookingDetails
                            ?.advance_deposit_credit_card_id &&
                        depositCard?.id !== 0 ? (
                          <Grid item lg={4} md={4} xs={12}>
                            <Button
                              variant="contained"
                              onClick={handleChangeDepositCard}
                              title="Cancel"
                              className="comman-button"
                              // style={{
                              //   width: "fit-content",
                              //   height: "47px",
                              //   // marginTop: "10px",
                              // }}
                            >
                              {t("Change Deposit Card")}
                            </Button>
                          </Grid>
                        ) : (
                          ""
                        )}
                        {depositCard?.id == 0 ||
                        Number.isNaN(depositCard?.id) ? (
                          <Grid item md={4} xs={12}>
                            <Button
                              variant="contained"
                              onClick={addDepoCardDetail}
                              title="Cancel"
                              className="comman-button"
                              // style={{
                              //   width: "150px",
                              //   height: "47px",
                              //   // marginTop: `${!onlyCard?'-10px':'36px'}`,
                              // }}
                            >
                              {t("Add & Verify")}
                            </Button>
                          </Grid>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </div>

                    {/* </Grid> */}
                  </div>
                  <div className="py-2">
                    <Typography
                      id="font-600"
                      style={{
                        marginBottom: "11px",
                        color: "#1E1E1E",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                      variant="h4"
                    >
                      {t("Split Bill")}
                    </Typography>

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={splitBill}
                          onChange={(e) => {
                            const checked = e.target.checked;

                            setSplitBill(checked);

                            if (checked) {
                              setShowPaymentMessage(true);
                              setOpenMakePaymentDialog(true);
                            } else {
                              setShowPaymentMessage(false);
                            }
                          }}
                        />
                      }
                      label={t("Want to split bill")}
                    />
                  </div>

                  <div
                    className="d-flex"
                    style={{
                      width: "100%",
                      minHeight: "70px",
                      margin: "auto",
                      justifyContent: "end",
                    }}
                  >
                    <div
                      style={{
                        width: "100%",
                        padding: "0px",
                        alignItems: "center",
                      }}
                      className="d-flex"
                    >
                      <Grid container spacing={2} alignItems="end">
                        <Grid item>
                          <Button
                            className="mt-1 comman-cancel-button"
                            size="large"
                            variant="contained"
                            disableElevation
                            // type="submit"
                            color="primary"
                            // style={{
                            //   justifyContent: "center",
                            //   width: "98px",
                            //   height: "44px",
                            //   textTransform: "capitalize",
                            //   background: "gray",
                            // }}
                            //   onClick={() => props.handleDialogClose()}
                            onClick={() => handleDialogClose1()}
                          >
                            {t("Close")}
                          </Button>
                        </Grid>
                        <Grid item>
                          <Button
                            className="mt-1 comman-button"
                            size="large"
                            variant="contained"
                            disableElevation
                            // type="submit"
                            color="primary"
                            type="submit"
                            disabled={loading}
                          >
                            {bookingInfo?.payment_type !== 4 &&
                            !(
                              +bookingInfo?.booking_source === 3 &&
                              bookingInfo?.ota_source?.toLowerCase() ===
                                "airbnb"
                            )
                              ? t("Confirm & Authorise")
                              : t("Confirm")}
                          </Button>
                        </Grid>
                        {bookingInfo?.payment_type !== 4 &&
                          !(
                            +bookingInfo?.booking_source === 3 &&
                            bookingInfo?.ota_source?.toLowerCase() === "airbnb"
                          ) && (
                            <Grid item>
                              <Button
                                className="mt-1 comman-button"
                                size="large"
                                variant="contained"
                                disableElevation
                                disabled={loading}
                                onClick={() =>
                                  handleOpenSmsEmail(props?.values, true)
                                }
                                color="primary"
                                // type="submit"
                              >
                                {t("Confirm & Charge")}
                              </Button>
                            </Grid>
                          )}
                      </Grid>
                    </div>
                  </div>

                  {/* <DisplayFormikState {...props} /> */}
                </form>
              );
            }}
          </Formik>
          <ConfirmDialog
            scroll="paper"
            maxWidth="md"
            title={t("Confirm The Action")}
            message={t("Do you want to send sms/email to the user?")}
            cancelButtonText={t("No")}
            confirmButtonText={t("Yes")}
            openDialog={openSendSmsEmailDialog}
            handleDialogCloseAction={() => handleCheckinSubmit(0)}
            handleDialogClose={() => setOpenSendSmsEmailDialog(false)}
            handleDialogAction={() => handleCheckinSubmit(1)}
          />
        </>
      ) : null}
    </div>
  );
};

export default ReservationCheckIn;
